import React, { useState } from "react";
import "./AddLoadForm.css";
import Button from "../../../components/Button/Button";
import TextInput from "../../../components/TextInput/TextInput";
/**Firebase Imports**/
import {
	auth,
	db,
	collection,
	setDoc,
	getDoc,
	doc,
} from "../../../firebaseConfig";
import { showError } from "../../../helpers/showError";

const AddLoadForm = ({ setShowAddForm }) => {
	const loadsRef = collection(db, "weekly_loads");
	const [isProcessing, setIsProcessing] = useState(false);

	const [loadName, setLoadName] = useState({
		value: "",
		error: "",
	});
	const [rate, setRate] = useState({
		value: "",
		error: "",
	});
	const [miles, setMiles] = useState({
		value: "",
		error: "",
	});

	/**
	 * Main Functions
	 */
	const handleAddLoad = async () => {
		setIsProcessing(true);
		if (checkErrors()) {
			var tempArr = [];
			const docSnap = await getDoc(
				doc(db, "weekly_loads", auth.currentUser.uid)
			);
			if (docSnap.exists()) {
				const loadsTemp = docSnap.data().loads;
				if (loadsTemp !== undefined) {
					tempArr = loadsTemp;
				}
			}
			tempArr.push({
				name: loadName.value,
				rate: rate.value,
				miles: miles.value,
			});
			await setDoc(doc(loadsRef, auth.currentUser.uid), {
				loads: tempArr,
			})
				.then(() => {
					//costs updated
					// alert("Load added successfully");
					setShowAddForm(false);
					setIsProcessing(false);
				})
				.catch((error) => {
					showError(error);
					setShowAddForm(false);
					setIsProcessing(false);
				});
		}
		setIsProcessing(false);
	};

	/**
	 * Utility Functions
	 */
	function checkErrors() {
		var noErrors = true;
		if (loadName.value === "") {
			setLoadName({ value: "", error: "*Load Name cannot be empty" });
			noErrors = false;
		}
		if (rate.value < 0 || rate.value === "") {
			setRate({ value: "", error: "*Rate cannot be negative" });
			noErrors = false;
		}
		if (miles.value <= 0 || miles.value === "") {
			setMiles({ value: "", error: "*Miles should be more than 0" });
			noErrors = false;
		}
		return noErrors;
	}
	return (
		<div className="AddLoadForm">
			<div className="rectangle flex flex-col items-center">
				<div className="polygon">
					<svg
						width="44"
						height="38"
						viewBox="0 0 44 38"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M22.232 0L43.8641 37.5318H0.599916L22.232 0Z"
							fill="#FFFEFE"
						/>
					</svg>
				</div>
				<TextInput
					placeholder={"Load Name"}
					className={"shadow-none"}
					type={"text"}
					name={"loadName"}
					id={"loadName"}
					value={loadName.value}
					onChange={(e) => {
						setLoadName({ value: e.target.value, error: "" });
					}}
					error={loadName.error !== ""}
					errorMessage={loadName.error}
				/>
				<TextInput
					placeholder={"Rate"}
					className={"mt-6 shadow-none"}
					type={"number"}
					name={"rate"}
					id={"rate"}
					value={rate.value}
					onChange={(e) => {
						setRate({ value: e.target.value, error: "" });
					}}
					error={rate.error !== ""}
					errorMessage={rate.error}
				/>
				<TextInput
					placeholder={"No. of Miles"}
					className={"mt-6 shadow-none"}
					type={"number"}
					name={"miles"}
					id={"miles"}
					value={miles.value}
					onChange={(e) => {
						setMiles({ value: e.target.value, error: "" });
					}}
					error={miles.error !== ""}
					errorMessage={miles.error}
				/>

				<Button
					mode={"filled"}
					size={"lg-1"}
					title={isProcessing ? "o o o" : "CREATE LOAD"}
					disabled={isProcessing}
					className={"mt-7"}
					onClick={() => handleAddLoad()}
				/>
			</div>
		</div>
	);
};

export default AddLoadForm;
